(function () {
    'use strict';

    angular
        .module('app')
        .controller('libraryNameSwitch', libraryNameSwitch);

    libraryNameSwitch.$inject = ['$scope', 'fileGuideService', 'storageService', 'libraryService']; 

    function libraryNameSwitch($scope, fileGuideService, storageService, libraryService) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'libraryNameSwitch';
        $scope.show = false;
        activate();
        function activate() {
            $scope.fileGuideService = fileGuideService;
            $scope.toggleDisplay = function () {
                $scope.show = !$scope.show;
            }
            $scope.selectionMade = function (showFolder) {
                if (showFolder) {
                    libraryService.sortByFolder();
                }
                else {
                    libraryService.sortByName();
                }
                fileGuideService.showFolder = showFolder;
                storageService.lbShowFolder = showFolder;
            }
        }
    }
})();
